import script from "./PlatformOperationVerification.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlatformOperationVerification.vue?vue&type=script&setup=true&lang=ts"

import "./PlatformOperationVerification.vue?vue&type=style&index=0&id=47ac3984&scoped=true&lang=css"

import exportComponent from "../../../../../../../ldplatform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47ac3984"]])

export default __exports__